
import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';
import { useStrings } from '../../hooks/useStrings';
import Reveal from '../ui/Reveal';

const FOOTER_LINK_CLASS =
  'text-gray-300 hover:text-infinity-yellow hover:translate-x-1 transition-all duration-200 inline-block';

const Footer: React.FC = () => {
  const { strings } = useStrings();

  return (
    <footer className="bg-infinity-black text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <Reveal className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-infinity-yellow rounded-full flex items-center justify-center">
                <img
                  src="/images/01-homepage/logoinfinitywits.svg"
                  className="w-8 h-8 object-contain rounded-full"
                />
              </div>
              <div>
                <h3 className="text-xl font-bold">Infinitywits</h3>
                <p className="text-sm text-gray-400">Energía Eléctrica</p>
              </div>
            </div>
            <p className="text-gray-300 mb-4">
              Especialistas en soluciones de energía renovable, ofreciendo productos y servicios
              de calidad para un futuro sostenible.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Mail size={16} />
                <span>gerencia@infinitywits.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail size={16} />
                <span>ventas@infinitywits.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail size={16} />
                <span>operaciones@cppvyf.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone size={16} />
                <span>+51 921 259 616</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin size={16} />
                <span>Lima, Perú</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-infinity-yellow">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li><a href="/" className={FOOTER_LINK_CLASS}>Inicio</a></li>
              <li><a href="/productos" className={FOOTER_LINK_CLASS}>Productos</a></li>
              <li><a href="/services" className={FOOTER_LINK_CLASS}>Servicios</a></li>
              <li><a href="/about" className={FOOTER_LINK_CLASS}>Nosotros</a></li>
              <li><a href="/contact" className={FOOTER_LINK_CLASS}>Contacto</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-infinity-yellow">Servicios</h4>
            <ul className="space-y-2">
              <li><a href="/services" className={FOOTER_LINK_CLASS}>Servicios</a></li>
              <li><a href="/mantenimiento" className={FOOTER_LINK_CLASS}>Mantenimiento</a></li>
              <li><a href="/capacitaciones" className={FOOTER_LINK_CLASS}>Capacitaciones</a></li>
              <li><a href="/contact" className={FOOTER_LINK_CLASS}>Soporte 24/7</a></li>
            </ul>
          </div>
        </Reveal>

        {/* Social Links & Copyright */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="flex space-x-4 mb-4 md:mb-0">
            <a href="https://www.facebook.com/profile.php?id=61579361469630" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-infinity-yellow hover:scale-110 hover:shadow-glow rounded-full p-1 transition-all duration-300">
              <Facebook size={20} />
            </a>
            <a href="https://www.instagram.com/infinitywits.pe/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-infinity-yellow hover:scale-110 hover:shadow-glow rounded-full p-1 transition-all duration-300">
              <Instagram size={20} />
            </a>
            <a href="https://www.tiktok.com/@infinitywits.pe" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-infinity-yellow hover:scale-110 hover:shadow-glow rounded-full p-1 transition-all duration-300">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
              </svg>
            </a>
          </div>
          <p className="text-gray-400 text-sm">
            © 2024 Infinitywits. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;